// Generated by CoffeeScript 1.12.7
(function() {
  $(function() {
    var LoginFormView;
    LoginFormView = new window.LoginForm;
    return LoginFormView.render();
  });
}).call(this);
